/**
 * Created by jonas on 2022-08-12.
 */
import {CounterDisplay} from "./CounterDisplay";
import {TheCageGameAssets} from "../TheCageGameAssets";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TheCage} from "../TheCage";
import {gsap} from "gsap";
import {MathUtils} from "../utils/MathUtils";

export class MultiplierDisplay extends CounterDisplay{
    get value():number {
        return this._value;
    }
    private _value:number;
    private explodeGfx:TimelineSprite;
    private explodeAnimation:gsap.core.Timeline;
    private glow:PIXI.Sprite;

    constructor() {
        super({
            fontName : TheCageGameAssets.BITMAP_FONT_MULTIPLIER_COUNTER,
            fontSize : 100,
            tint : 0xffffff
        });
        this._value = 1;

        this.glow = new PIXI.Sprite(TheCage.assetLoader.getTextures(TheCageGameAssets.COUNTER_GLOW)[0]);
        this.glow.anchor.set(0.5, 0.5);
        this.glow.scale.set(1.5,1.5);
        this.glow.alpha = 0;
        this.glow.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(this.glow);

     /*   this.explodeGfx = new TimelineSprite(Octagon.assetLoader.getTextures(OctagonGameAssets.MULTIPLIER_UPDATE),30);
        this.explodeGfx.anchor.set(0.5,0.5);
        this.explodeGfx.blendMode = PIXI.BLEND_MODES.ADD;
        this.addChild(this.explodeGfx);

        this.explodeAnimation = this.explodeGfx.getAnimationAutoShowHide(true,true);*/

        this.update();
    }

    update(){
        const newScale = this._value > 4 ? 1 : 1 - (5-this._value) * 0.125;
        this._text.scale.set(newScale, newScale);
        const newGlowAlpha = Math.min(this._value, 5) * 0.25 - 0.25;
        this.glow.alpha = newGlowAlpha;
        this.setText("x" + this._value);
    }

    addMultiplier(value:number) {
        this._value += value;
        this.update();
        this.playAnimation();
    }

    reset(value:number = 1) {
        this._value = value;
        this.update();
    }

    public playAnimation(){
        const scale = Math.min(0.5 + 0.1 * this._value, 1);

        const explodeGfx = new TimelineSprite(TheCage.assetLoader.getTextures(TheCageGameAssets.MULTIPLIER_UPDATE),30);
        explodeGfx.anchor.set(0.5,0.5);
        explodeGfx.scale.set(scale,scale);
        explodeGfx.blendMode = PIXI.BLEND_MODES.ADD;

        const pos = MathUtils.randomPosInRect(new PIXI.Rectangle(-25,-25,50,50));
        explodeGfx.position.set(pos.x,pos.y);



        this.addChild(explodeGfx);

        explodeGfx.getAnimationAutoShowHide(true,true);

/*
        this.explodeGfx.scale.set(scale,scale);
        this.explodeAnimation.play(0);*/

    }

}